import * as colors from '@mui/material/colors';
import responsiveFontSizes from '@mui/material/styles/responsiveFontSizes';
import createTheme from "@mui/material/styles/createTheme";
import typography from './typography';
import {THEMES} from "../costants";
import {makeStyles} from "@mui/styles";

const baseOptions = {
    direction: 'ltr',
    typography,
    overrides: {
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: 'hidden'
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32
            }
        },
        MuiChip: {
            root: {
                backgroundColor: 'rgba(0,0,0,0.075)'
            }
        }
    }
};

const themesOptions = [
    {
        name: THEMES.LIGHT,
        typography,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600]
                    }
                }
            }
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600]
            },
            background: {
                default: colors.common.white,
                dark: '#f4f6f8',
                paper: colors.common.white
            },
            primary: {
                main: '#454545'
            },
            secondary: {
                main: '#737373'
            },
            text: {
                primary: '#454545',
                secondary: '#737373'
            },
        },
    },
    {
        name: THEMES.ONE_DARK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)'
            },
            background: {
                default: '#282C34',
                dark: '#1c2025',
                paper: '#282C34'
            },
            primary: {
                main: '#8a85ff'
            },
            secondary: {
                main: '#8a85ff'
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb'
            },
        },
    },

];

export const createMuiTheme = (config = {}) => {
    let themeOptions = themesOptions.find((theme) => theme.name === config.theme);

    if (!themeOptions) {
        console.warn(new Error(`The theme ${config.theme} is not valid`));
        [themeOptions] = themesOptions;
    }

    // Merge baseOptions + themeOptions + config
    const mergedOptions = {
        ...baseOptions,
        ...themeOptions,
        direction: config.direction || baseOptions.direction
    };

    let theme = createTheme(mergedOptions);

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};

export const useStyles = makeStyles((theme) => ({
    box: {
        marginTop: "4%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: "white",
        height: "64px",
        alignItems: "center",
        padding: " 0px 20px",
        color: "#161616",
        textDecoration: "none",
    },
    button: {
        backgroundColor: "#f5f5f5",
        borderRadius: "5px",
        color: "#02A29F",
        fontSize: "1rem",
        textTransform: "none",
        padding: "8px 76px",
        height: "40px",
        gap: "10px",
        cursor: "pointer",
        border: "2px solid #02A29F",
        fontWeight: "600",
    },
    button1: {
        borderRadius: "5px",
        borderColor: "#02A29F",
        color: "#02A29F",
        fontSize: "1rem",
        textTransform: "none",
        height: "40px",
        cursor: "pointer",
        fontWeight: "600",
        "&:hover": {
            backgroundColor: "#02A29F",
            borderRadius: "5px",
            color: "#fff",
            fontSize: "1rem",
            textTransform: "none",
            height: "40px",
            cursor: "pointer",
            fontWeight: "600",
        }
    },
    fab: {
        position: 'fixed',
        bottom: 80,
        left: '70%',
        transform: 'translateX(-50%)',
        backgroundColor: "#02A29F",
        color: "white",
        borderRadius: "100px",
        padding: "12px 24px",
        minWidth: "160px",
        textTransform: "none",
        fontSize: "16px",
        fontWeight: 500,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
        "&:hover": {
            backgroundColor: "#028e8b",
        },
        "& .MuiSvgIcon-root": {
            marginRight: "8px",
            fontSize: "20px"
        }
    }
}));
